"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerInputButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _focusRing = require("../../../../util/focusRing");
var _withFocusClassName = require("../../../../util/withFocusClassName");
var _colorPickerTheme = require("../../colorPickerTheme");
function createFocusRing(_ref) {
  let {
    themeMode
  } = _ref;
  const styles = (0, _focusRing.getFocusRingStyles)({
    theme: themeMode,
    includeFocusPseudoClass: true,
    offset: 4,
    radius: 5,
    position: "absolute"
  });
  return styles;
}
const ColorPickerInputButton = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("button")`
    width: auto;
    height: 24px;
    cursor: pointer;
    border-radius: 2px;
    border: none;
    color: ${(0, _designTokensReact.color)("color--text--primary--strong")};
    position: absolute;
    background: transparent;
    top: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _colorPickerTheme.colorPickerTheme.inputDot.top(themeMode);
}};
    right: 8px;

    &:hover {
        outline: none;
        background: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _colorPickerTheme.colorPickerTheme.inputButton.backgroundColor.hover(themeMode);
}};
    }

    &:active {
        color: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _colorPickerTheme.colorPickerTheme.inputButton.textColor.active(themeMode);
}};
        background: ${(0, _designTokensReact.color)("color--background--neutral--default")};
    }

    &:focus {
        background: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _colorPickerTheme.colorPickerTheme.inputButton.backgroundColor.hover(themeMode);
}};
    }

    ${createFocusRing}

    &[aria-disabled="true"] {
        cursor: not-allowed;
        color: ${(0, _designTokensReact.color)("color--text--neutral--weaker")};
    }
`);
exports.ColorPickerInputButton = ColorPickerInputButton;
//# sourceMappingURL=ColorPickerInputButton.js.map